import React from 'react';
import { isEmpty } from 'lodash';

import ListItem from '@material-ui/core/ListItem';

import styles from './Storyboard.module.scss';
import {
  MenuItem,
  Menu,
  IconButton,
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
export default class PspUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {anchorEl: null};
  }

  render() {
    const open = Boolean(this.state.anchorEl);
    const handleClick = (event) => {
      this.setState({anchorEl : event.currentTarget});
    };
    const handleClose = () => {
      this.setState({anchorEl : null});
    };

    const { user } = this.props;
    console.log(user,'user')
    if (isEmpty(user)) return null;   

    let borderColor = '#52A8EF';
    let borderStyle = 'none';
    let paddingRight,
    paddingBottom = '0px';

    return (
      <div
        style={{
          borderColor,
          borderStyle,
          paddingRight,
          paddingBottom,
        }} 
      >
        <ListItem
          className={styles.root}  
        >
          <div className={styles.clue}>
            <div>{user.email_address}</div>            
            <div>
            <IconButton  
              aria-label="more"
              id="long-button"
              aria-controls={open ? 'long-menu' : undefined}
              aria-expanded={open ? 'true' : undefined}
              aria-haspopup="true"
              style={{padding: '5px'}}
              onClick={handleClick}
              >
                <MoreVertIcon />
              </IconButton>
            <Menu 
              id="long-menu" 
              MenuListProps={{
                'aria-labelledby': 'long-button',
              }}
              anchorEl={this.state.anchorEl}
              open={open}
              onClose={handleClose}>
                <MenuItem 
                style={{color:"#434F69",fontFamily: 'gilroy-regular'}}
                 onClick={() => {
                  const confirm = window.confirm("Are you sure you would like to permanently remove this user?")
                    if(confirm){
                      this.props.deleteProviderLinkedUserFunc(this.props.provider.id,user);
                    }
                 handleClose();}}>Remove</MenuItem>
            </Menu>
            </div>
          </div>
        </ListItem>
      </div>
    );
  }
}
